// @ts-nocheck
import Typography from "@store/MobiusOverrides/Typography/Typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import useInfinteScroll from "@store/Framework/Common/Hooks/useInfiniteScroll";
import useLocalizeCurrency from "@store/Framework/Common/Hooks/useLocalizeCurrency";
import useReportApi from "@store/Framework/Common/Hooks/useReportAPI/useReportAPI";
import useSearch from "@store/Framework/Common/Hooks/useSearch";
import { ExpenditureByPurchaserItemModel } from "@store/Framework/Services/Reporting/ReportingModels";
import { isExpenditureByPurchaserModel } from "@store/Framework/Services/Reporting/ReportingTypeGuards";
import { reportParametersSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencySelectors";
import useClear from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useClear";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import ReportDataTable, {
    DataTableData,
    FormatDictionary,
} from "@store/Library/Components/Reporting/ApiDataTable/ReportDataTable";
import AccordionLayout from "@store/Library/Components/Reporting/Common/AccordionLayout";
import ApiButtons from "@store/Library/Components/Reporting/Common/ApiButtons";
import ReportContainer from "@store/Library/Components/Reporting/Common/ReportContainer";
import ReportingFilterGridItem from "@store/Library/Components/Reporting/Common/ReportingFilterGridItem";
import { LocationPicker } from "@store/Library/Components/Reporting/LocationPicker/LocationPicker";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import React from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

const headers = [
    "User Name",
    "Location",
    "Ship to Address",
    "Count",
    "Item Total",
    "Freight Total",
    "Tax Total",
    "Order Total",
];
const datakeys: (keyof ExpenditureByPurchaserItemModel)[] = [
    "username",
    "name",
    "shiptoaddress",
    "ordercount",
    "itemstotal",
    "freighttotal",
    "taxtotal",
    "ordertotal",
];
const DatePicker = getWidgetComponent("Reports/ReportSearchFieldDateRange");

const ExpenditureByPurchaserReport = () => {
    const onClear = useClear();
    const reportParameters = useSelector(reportParametersSelector);
    const { isError, updateData, isLoading, hasSubmitted, setHasSubmitted } = useReportApi("expenditureByPurchaser");
    const [tableData, setTableData] = React.useState<ExpenditureByPurchaserItemModel[]>([]);
    const handleDataUpdate = async () => {
        const data = await updateData({ ...reportParameters });
        if (isExpenditureByPurchaserModel(data)) {
            setTableData(data.items);
        }
    };
    const handleClear = () => {
        onClear();
        setHasSubmitted(false);
        setTableData([]);
    };
    const localizeCurrency = useLocalizeCurrency();
    const formatDictionary: FormatDictionary = {
        itemstotal: localizeCurrency,
        freighttotal: localizeCurrency,
        taxtotal: localizeCurrency,
        ordertotal: localizeCurrency,
    };
    const expenditureByPurchaserTableData: DataTableData<ExpenditureByPurchaserItemModel> = {
        headers,
        title: translate("Expenditure By Purchaser Report"),
        data: tableData,
        dataKeys: datakeys,
        dataSummaryTitle: translate("Expenditures"),
        formatDictionary,
    };
    return (
        <ReportContainer>
            <AccordionLayout>
                <ReportingFilterGridItem doubleSized={true}>
                    <DatePicker />
                </ReportingFilterGridItem>
                <ReportingFilterGridItem>
                    <LocationPicker isError={isError} />
                </ReportingFilterGridItem>
                <ApiButtons onClear={handleClear} updateData={handleDataUpdate} isLoading={isLoading} />
            </AccordionLayout>
            <StyledWrapper
                css={css`
                    overflow: auto;
                `}
            >
                {tableData.length !== 0 && <ReportDataTable dataTableData={expenditureByPurchaserTableData} />}
                {hasSubmitted && !isLoading && tableData.length === 0 && (
                    <Typography as="p" variant="h3">
                        {translate("No results found")}
                    </Typography>
                )}
            </StyledWrapper>
        </ReportContainer>
    );
};
const widgetModule: CustomWidgetModule = {
    component: ExpenditureByPurchaserReport,
    definition: {
        group: "Reporting",
        displayName: "Expenditure By Purchaser Report",
    },
};

export default widgetModule;
